import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth';

export const chatwootTeamsApi = createApi({
  reducerPath: 'chatwootTeamsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['ChatwootTeams'],
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: (params = {}) => ({
        url: '/chatwoot/teams',
        method: 'GET',
        params: {
          page: params.page,
          limit: params.limit
        }
      }),
      providesTags: ['ChatwootTeams'],
    }),
    
    getTeam: builder.query({
      query: (teamId) => `/chatwoot/teams/${teamId}`,
      providesTags: (result, error, teamId) => [{ type: 'ChatwootTeams', id: teamId }],
    }),

    getTeamByTeamId: builder.query({
      query: (teamId) => `/chatwoot/teams/by-team-id/${teamId}`,
      providesTags: (result, error, teamId) => [{ type: 'ChatwootTeams', id: teamId }],
    }),
    
    createTeam: builder.mutation({
      query: (teamData) => ({
        url: '/chatwoot/teams',
        method: 'POST',
        body: teamData,
      }),
      invalidatesTags: ['ChatwootTeams'],
    }),
    
    updateTeam: builder.mutation({
      query: ({ id, ...teamData }) => ({
        url: `/chatwoot/teams/${id}`,
        method: 'PUT',
        body: teamData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ChatwootTeams', id },
        'ChatwootTeams'
      ],
    }),
    
    deleteTeam: builder.mutation({
      query: (teamId) => ({
        url: `/chatwoot/teams/${teamId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ChatwootTeams'],
    }),

    generateTeams: builder.mutation({
      query: () => ({
        url: '/chatwoot/generate-teams',
        method: 'GET'
      }),
      invalidatesTags: ['ChatwootTeams'],
    }),
  }),
});

export const {
  useGetTeamsQuery,
  useGetTeamQuery,
  useGetTeamByTeamIdQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
  useGenerateTeamsMutation,
} = chatwootTeamsApi; 